import React from 'react';

import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from 'e100-react-components';
import { Icon } from 'components';
import { DrawerHeader } from 'shared/components';

import {
  ShowMenu,
  HandleCloseMenu
} from 'shared/hooks';

import hereMap from '../DesktopMapTypeSwitcher/HereMap.svg';
import googleMap from '../DesktopMapTypeSwitcher/GoogleMap.svg';

import {
  useIsActiveGoogleMap,
  useIsActiveHereMap
} from 'entities/map';
import { useHandleClickMapType } from '../../hooks';
import { useIntl } from 'react-intl';
import { useStyles } from './styles';

import { MAP_NAMES } from 'entities/map';

export const MapTypes = ({
  handleCloseMenu,
  showMenu
}: MapTypesProps) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const isActiveGoogleMap = useIsActiveGoogleMap();
  const isActiveHereMap = useIsActiveHereMap();
  const handleClickMapType = useHandleClickMapType();

  return (
    <Drawer
      anchor={'bottom'}
      onClose={handleCloseMenu}
      open={showMenu}
      variant={'temporary'}
      classes={{ paper: classes.drawer }}
    >
      <div onMouseDown={(event) => { event.stopPropagation(); }}>
        <List classes={{ root: classes.list }}>
          <ListItem>
            <DrawerHeader
              onClick={handleCloseMenu}
              title={formatMessage({ id: 'mapType' })}
            />
          </ListItem>
          <ListItem
            button
            onClick={() => {
              handleClickMapType(MAP_NAMES.google);
            }}
          >
            <ListItemIcon>
              <img src={googleMap} alt="Google map icon" />
            </ListItemIcon>
            <ListItemText primary={formatMessage({ id: 'googleMap' })} />
            { isActiveGoogleMap && <Icon kind="done" color="primary" /> }
          </ListItem>
          <ListItem
            button
            onClick={() => {
              handleClickMapType(MAP_NAMES.here);
            }}
          >
            <ListItemIcon>
              <img src={hereMap} alt="Here map icon" />
            </ListItemIcon>
            <ListItemText primary={formatMessage({ id: 'hereMap' })} />
            { isActiveHereMap && <Icon kind="done" color="primary" /> }
          </ListItem>
        </List>
      </div>
    </Drawer>
  );
};

interface MapTypesProps {
  showMenu: ShowMenu;
  handleCloseMenu: HandleCloseMenu;
}